import React from "react";
import "./ClientSummaryCard.css";

const ClientSummaryCard = ({ client }) => {
    // console.log(client);
  if (!client) return null;

  const data = client|| {};

  return (
    <div className="partner-wc-portfolio-summary-wrapper">

      {/* BASIC INFO */}
      <div className="partner-wc-portfolio-card">
        <h3 className="partner-wc-portfolio-title">Client Info</h3>
        <div className="partner-wc-portfolio-grid">
          <div>Name: {client?.client_name || "NA"}</div>
          <div>Code: {client?.client_code || "NA"}</div>
          <div>Monthly Income: ₹{client?.monthlyIncome || "NA"}</div>
        </div>
      </div>

      {/* CAPITAL OVERVIEW */}
      <div className="partner-wc-portfolio-card">
        <h3 className="partner-wc-portfolio-title">Capital Overview</h3>
        <div className="partner-wc-portfolio-grid">
          <div>Total Capital: ₹{data?.portfolioManagement?.totalCapital}</div>
          <div>Available Trade Capital: ₹{data?.portfolioManagement?.availableTradeCapital}</div>
          <div>PnL FY: ₹{data?.portfolioManagement?.pnlFY}</div>
          <div>Recoverable Loss: ₹{data?.portfolioManagement?.recoverableLossFY}</div>
        </div>
      </div>

      {/* OPTIONS */}
      <div className="partner-wc-portfolio-card highlight">
        <h3 style={{color:'white'}} className="partner-wc-portfolio-title">Options ({data.portfolioManagement?.optionsCapitalCap}%)</h3>
        <div className="partner-wc-portfolio-grid">
          <div>Capital: ₹{data.portfolioManagement?.optionsCapital}</div>
          <div>Invested: ₹{data.portfolioManagement?.optionsAllocation}</div>
          <div>Remaining: ₹{data.portfolioManagement?.finalOptionsBalance}</div>
        </div>
      </div>

      {/* EQUITY SPLIT */}
      <div className="partner-wc-portfolio-card">
        <h3 className="partner-wc-portfolio-title">Equity Distribution</h3>

        <div className="partner-wc-portfolio-split">
          <div>
            <span>Positional ({data.portfolioManagement?.positionalCap}%)</span>
            <b>₹{data.portfolioManagement?.positionalFund}</b>
          </div>

          <div>
            <span>Swing ({data.portfolioManagement?.swingCap}%)</span>
            <b>₹{data.portfolioManagement?.swingFund}</b>
          </div>

          <div>
            <span>Intraday ({data.portfolioManagement?.intradayCap}%)</span>
            <b>₹{data.portfolioManagement?.intradayFund}</b>
          </div>

          <div>
            <span>Reserve ({data.portfolioManagement?.reserveCap}%)</span>
            <b>₹{data.portfolioManagement?.reserveFund}</b>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ClientSummaryCard;